import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {emitTrackEvent} from 'common/util/dom';

import {BreadcrumbsState, LinkNode} from './types';
import {TrackingEvent} from './tracking';
import {template} from './template';
import css from './index.styl?inline';

const COMPONENT_NAME = `mp-breadcrumbs`;

interface BreadcrumbsJsxProps {
  attrs?: BreadcrumbsAttrs;
  props: {
    inkNodes: LinkNode[];
  };
}

interface BreadcrumbsAttrs {
  'track-name'?: string;
}

export class Breadcrumbs extends Component<BreadcrumbsState, BreadcrumbsAttrs> {
  static get attrsSchema(): AttrsSchema<BreadcrumbsAttrs> {
    return {
      'track-name': {
        type: `string`,
        description: `If specified, fire a track event and track call`,
      },
      ...super.attrsSchema,
    };
  }
  get config(): ConfigOptions<BreadcrumbsState> {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        linkNodes: [],
      },
      helpers: {
        nodeClicked: (node, index) => {
          this.dispatchEvent(new CustomEvent(`nodeClick`, {detail: {node, index}}));
          const props = {...node, index, eventName: this.attr(`track-name`)};
          if (this.attr(`track-name`)) {
            emitTrackEvent(this, {
              eventName: TrackingEvent.ClickedLink,
              eventPrefix: COMPONENT_NAME,
              props,
            });
          }
        },
      },
    };
  }

  get linkNodes() {
    return this.state.linkNodes;
  }

  set linkNodes(linkNodes: LinkNode[]) {
    this.update({linkNodes});
  }
}

export const BreadcrumbsEl = defineAndMakeJsxFactory<BreadcrumbsJsxProps>(COMPONENT_NAME, Breadcrumbs);
